import download from './download';
import remove from './remove';
import add from './add';
import get from './get';

export default [get, remove, download, add];
